module.exports = __webpack_public_path__ + "static/media/greeting.4d39311f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/auth/ui/screens/login-by-email/greeting.svg
// module id = 838
// module chunks = 0